import { fileUrl } from '@/utils/fileUrl';

export const getImage = async (idPhoto: string): Promise<string | null> => {
    return new Promise((resolve) => {
        const fileURL = fileUrl(idPhoto, 100, 100, 0);

        const img = new Image();
        img.src = fileURL;

        img.onload = () => {
            resolve(fileURL);
        };

        img.onerror = () => {
            resolve(null);
        };
    });
};
